module.exports = __webpack_public_path__ + "static/hero-devices-mobile-89245cb2b257716a6146e65d5116b32b.svg";